import { FILTER_FIELDS } from '@constants';

export const repairFields = {
  'customFields.vehiclePlate': {
    ...FILTER_FIELDS.String,
    label: 'Vehicle Plate',
  },
  'customFields.dateToServicePoint': {
    ...FILTER_FIELDS.Date,
    label: 'Date To Service Point',
  },
  'customFields.requestDate': {
    ...FILTER_FIELDS.Date,
    label: 'Request Date',
  },
  'customFields.expectedOutFromServicePoint': {
    ...FILTER_FIELDS.Date,
    label: 'Expected Out from Service Point',
  },
};
